module.exports = "/assets/e0992b44c3d79cc9e13e872ca5ed591c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/Q7.png
// module id = 2864
// module chunks = 0